import React from "react";

import PropTypes from "prop-types";

import { defaultTemplate } from "core/hoc";
import { BasicInput, BaasicButton, BasicFieldCheckbox } from "core/components";

function UserPasswordChangeTemplate(props) {
    const { userPasswordChangeViewStore, t } = props;
    const { userPasswordChangeForm } = userPasswordChangeViewStore;

    return (
        <section>
            <form className="form" onSubmit={userPasswordChangeForm.onSubmit}>
                <div className="modal__header">
                    <h3 className="modal__header__title">Change Password</h3>
                </div>
                <div className="modal__body">
                    <div className="form__group">
                        <BasicInput
                            field={userPasswordChangeForm.$("newPassword")}
                        />
                    </div>
                    <div className="u-display--ib">
                        <BasicFieldCheckbox
                            field={userPasswordChangeForm.$(
                                "sendMailNotification"
                            )}
                            label={t(
                                "USER.PASSWORD_CHANGE.SEND_PASSWORD_CHANGE_EMAIL_LABEL"
                            )}
                        />
                    </div>
                </div>
                <div className="modal__footer is-right">
                    <BaasicButton
                        className="btn btn--med btn--primary"
                        type="submit"
                        label="Submit"
                        disabled={
                            userPasswordChangeForm.submitting ||
                            userPasswordChangeForm.validating ||
                            !userPasswordChangeForm.isValid
                        }
                    />
                </div>
            </form>
        </section>
    );
}

UserPasswordChangeTemplate.propTypes = {
    userPasswordChangeViewStore: PropTypes.object,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(UserPasswordChangeTemplate);
